import React from "react";

const DataTable = ({ columns, data, emptyMessage = "No data available" }) => {
  if (!data || data.length === 0) {
    return <div className="text-center py-4">{emptyMessage}</div>;
  }

    return (
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={row._id || index}>
                {columns.map((col) => (
                  <td key={col.key}>
                    {col.render ? col.render(row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
};

export default DataTable;
